module.exports = __webpack_public_path__ + "static/media/login-icon.9350e334.svg";